import { render, staticRenderFns } from "./EquipmentsPage.vue?vue&type=template&id=906f729e&scoped=true&"
import script from "./EquipmentsPage.vue?vue&type=script&lang=js&"
export * from "./EquipmentsPage.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentsPage.vue?vue&type=style&index=0&id=906f729e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906f729e",
  null
  
)

export default component.exports